import { PaginationContext } from './api.common.types';

export enum ProfileType {
  STAFF = 'staff',
}

export type LoginPayload = {
  password: string;
  userName: string;
};

export type TokenData = {
  accessToken: string;
  accessTokenType: string;
  accessTokenExpiresIn: number;
  refreshToken: string;
  refreshTokenExpiresIn: number;
  uniqueId: string;
};

export type LoginResponse = {
  tokenData: TokenData;
};

export type SendCodeResponse = {
  phoneLastFourDigits: string;
};

export type SuccessResponse = {
  success: boolean;
};

export type ConfirmPayload = {
  code: string;
};

export type ConfirmResponse = {
  tokenData: TokenData;
  dashboard: 'adminDashboard' | 'employerDashboard';
};

export type ProfileResponse = {
  id: number;
  companyName?: string;
  displayName: string;
  email: string;
  profileStatus?: string;
  profileType: ProfileType;
  defaultEtzFee?: number;
  defaultCustodyFeePercentageIraClub?: number;
};

export type ProfileListItem = {
  profileType: string;
  profileTypeTitle: string;
  iraNumber: string;
  employerName: string;
  profileStatus: string;
};

export type ProfileListResponse = {
  items: ProfileListItem[];
  context: PaginationContext;
};
